// extracted by mini-css-extract-plugin
export default {"servicesWrapper":"Dashboard_servicesWrapper__isScI"};